import { LocaleIcons, LocaleNames } from '@/enums/general'
import i18nConfig from '@/config/i18n'
import { mapState } from 'vuex'

export default {
  data () {
    const languageItems = Object.keys(LocaleNames).map(code => ({
      svg: LocaleIcons[code],
      iconClasses: ['rounded-sm'],
      label: LocaleNames[code],
      value: code
    }))

    return {
      languageDropdownSettings: {
        currentLanguage: {
          svg: LocaleIcons[i18nConfig.defaultLocale],
          label: LocaleNames[i18nConfig.defaultLocale],
          value: i18nConfig.defaultLocale
        },
        items: languageItems
      }
    }
  },
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  watch: {
    locale (locale) {
      this.languageDropdownSettings.currentLanguage = {
        svg: LocaleIcons[locale],
        text: LocaleNames[locale],
        value: locale
      }
    }
  },
  created () {
    this.$moment.locale(this.locale)
    this.languageDropdownSettings.currentLanguage = {
      svg: LocaleIcons[this.locale],
      label: LocaleNames[this.locale],
      value: this.locale
    }
  }
}
